import { render, staticRenderFns } from "./MenuSearch.vue?vue&type=template&id=bdae312c&"
import script from "./MenuSearch.vue?vue&type=script&lang=js&"
export * from "./MenuSearch.vue?vue&type=script&lang=js&"
import style0 from "./MenuSearch.vue?vue&type=style&index=0&id=bdae312c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdae312c')) {
      api.createRecord('bdae312c', component.options)
    } else {
      api.reload('bdae312c', component.options)
    }
    module.hot.accept("./MenuSearch.vue?vue&type=template&id=bdae312c&", function () {
      api.rerender('bdae312c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/core/MenuSearch.vue"
export default component.exports